import { Select, TreeSelect } from "antd"
import '../../../style.scss'

import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { ColDef, GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Input, Pagination, PaginationProps } from 'antd';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { NodataTable } from "../../../../../../components/NoDataTable";
import { IDetailGroup } from "../../../../../../api/groupCustomerV2/groupCustomerV2Api";
import { dataPagination } from "../../../../../../until";
import useLoading from "../../../../../../hook/useLoading";
import { dataDefaulFilterList, IDataFilterGroupList } from "../../AddGroup/AddNewGroup";
import { getListUserAccount, IAccount } from "../../../../../../api/groupPermission/groupPermissionApi";
import useDebounce from "../../../../../../hook/useDebounce";
import { useSelector } from "react-redux";
import { selectorInfoUser } from "../../../../../../store/slices/infoUserSlice";
import { columnDefs, ISelectedUserAccount, PERMISSION } from "../../AddGroup/Component/AG_Decentralization";
import { useCustomerGroupContext } from "../../../indexV2";
import { formatNumber } from "../../../../../../services/mixin";

dayjs.locale('vi');




interface Props {
    isEdit: boolean
    inforGroup?: IDetailGroup
    listUserSelectedAccount: ISelectedUserAccount[]
    setListUserSelectedAccount: React.Dispatch<React.SetStateAction<ISelectedUserAccount[]>>
}
const VG_Decentralization: React.FC<Props> = ({
    isEdit, inforGroup, listUserSelectedAccount,
    setListUserSelectedAccount
}) => {
    const pushLoading = useLoading()
    const { groupPermission } = useSelector(selectorInfoUser)
    const {
        // sLUnit, sLCategoryCar
        sLNationwide
    } = useCustomerGroupContext();


    const isRestoringSelection = useRef(false);
    const gridApiRef = useRef<GridApi | null>(null);

    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
    const [tabPermission, setTabPermission] = useState(PERMISSION.VIEW)


    const [dataFilterList, setDataFilterList] = useState<IDataFilterGroupList>(dataDefaulFilterList)

    const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

    const [listUserAccount, setListUserAccount] = useState<IAccount[]>([]);
    const [permissionByUserId, setPermissionByUserId] = useState<
        Record<string, PERMISSION>
    >({});

    const permissionLabelMap: Record<PERMISSION, string> = {
        [PERMISSION.VIEW]: "Xem",
        [PERMISSION.EDIT]: "Sửa",
        [PERMISSION.DELETE]: "Sửa, Xóa",
    };


    useEffect(() => {
        if (!inforGroup?.listAdmin?.length) {
            setSelectedIds(new Set());
            setPermissionByUserId({});
            return;
        }

        const nextSelectedIds = new Set<string>();
        const nextPermissionByUserId: Record<string, PERMISSION> = {};

        inforGroup.listAdmin.forEach((item) => {
            const adminId = String(item.adminId);

            nextSelectedIds.add(adminId);
            nextPermissionByUserId[adminId] = item.permissionType as PERMISSION;
        });

        setSelectedIds(nextSelectedIds);
        setPermissionByUserId(nextPermissionByUserId);
    }, [inforGroup?.listAdmin]);

    const gListUserAccount = useDebounce(async (limit: number = 10, pageNumber: number = 1) => {
        pushLoading(true)
        // if (inforGroup?.id) return
        const { listUnit, search } = dataFilterList

        const result = await getListUserAccount(
            limit, pageNumber, listUnit, undefined,
            search, groupPermission ?? undefined, 1, inforGroup?.id
        );
        if (result.status) {
            setListUserAccount(result.data)
            setPagination({ current: pageNumber, total: result.total, pageSize: limit });

        } else {
            // pushToast(result.message, "error", 2000);
        }
        pushLoading(false)
    }, 1000)

    //------------------------------------



    const rowData = useMemo(() => {
        return (listUserAccount ?? []).map((item: any) => {
            const userId = String(item.id);
            const permission = permissionByUserId[userId];

            return {
                ...item,
                permission:
                    permission !== undefined
                        ? permissionLabelMap[permission]
                        : undefined,
            };
        });
    }, [listUserAccount, permissionByUserId]);


    const restoreSelection = useCallback(() => {
        const api = gridApiRef.current;
        if (!api) return;

        isRestoringSelection.current = true;

        api.forEachNode((node) => {
            if (!node.data?.id) return;

            const id = String(node.data.id);
            node.setSelected(selectedIds.has(id));
        });

        isRestoringSelection.current = false;
    }, [selectedIds]);

    useEffect(() => {
        restoreSelection();
    }, [restoreSelection, rowData]);
    // Định danh duy nhất cho mỗi row
    const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

    // --- Grid ready ---
    const onGridReady = useCallback((params: { api: GridApi }) => {
        gridApiRef.current = params.api;
    }, []);

    // --- Selection change ---
    const onSelectionChanged = useCallback(
        (event: SelectionChangedEvent) => {
            if (isRestoringSelection.current) return;

            const api = event.api;

            const selectedNodes = api.getSelectedNodes().filter((n) => n.data);
            const selectedIdsOnPage = selectedNodes.map((n) => String(n.data.id));

            const currentPageIds = (listUserAccount ?? []).map((row: any) =>
                String(row.id)
            );

            const nextSet = new Set(selectedIds);

            const added: string[] = [];
            const removed: string[] = [];

            for (const id of currentPageIds) {
                const isCurrentlySelected = selectedIdsOnPage.includes(id);
                const wasPreviouslySelected = selectedIds.has(id);

                if (isCurrentlySelected && !wasPreviouslySelected) {
                    added.push(id);
                    nextSet.add(id);
                } else if (!isCurrentlySelected && wasPreviouslySelected) {
                    removed.push(id);
                    nextSet.delete(id);
                }
            }

            // Cập nhật quyền cho row vừa được chọn
            if (added.length > 0) {
                setPermissionByUserId((prev) => {
                    const next = { ...prev };

                    added.forEach((id) => {
                        next[id] = tabPermission;
                    });

                    return next;
                });
            }

            // Nếu bỏ chọn thì xóa quyền khỏi row đó
            if (removed.length > 0) {
                setPermissionByUserId((prev) => {
                    const next = { ...prev };

                    removed.forEach((id) => {
                        delete next[id];
                    });

                    return next;
                });
            }

            handleChangeSelectedUserAccount(added, removed);

            setSelectedIds(nextSet);
        },
        [selectedIds, listUserAccount, tabPermission]
    );
    //------------------------------------

    // --- Cập nhật danh sách account được chọn ---
    const handleChangeSelectedUserAccount = (itemsAdd: string[], itemsRemove: string[]) => {
        setListUserSelectedAccount((prevList) => {
            // Nếu có add
            if (itemsAdd.length > 0) {
                const newUsers = itemsAdd.map((id) => ({
                    adminId: Number(id),
                    permissionType: tabPermission,
                }));
                return [...prevList, ...newUsers];
            }

            // Nếu có remove
            if (itemsRemove.length > 0) {
                return prevList.filter((user) => !itemsRemove.includes(user.adminId.toString()));
            }
            return prevList;
        });
    };

    // --- Khi đổi page ---
    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        gListUserAccount(pageSize, pageNumber);
    };

    // --- Khôi phục selection khi data mới load ---
    useEffect(() => {
        if (gridApiRef.current && listUserAccount && listUserAccount.length > 0) {
            isRestoringSelection.current = true;

            gridApiRef.current.forEachNode((node: any) => {
                if (node.data && selectedIds.has(String(node.data.id))) {
                    node.setSelected(true, false, true);
                } else {
                    node.setSelected(false, false, true);
                }
            });

            setTimeout(() => {
                isRestoringSelection.current = false;
            }, 0);
        }
    }, [listUserAccount, selectedIds]);

    // --- Clear selection từ button bên ngoài ---
    const handleClearSelection = () => {
        // setSelectedIds(new Set([92]));
        // setListUserSelectedAccount([]);
    };

    useEffect(() => {
        if (inforGroup) {
            // const adminIds = new Set(
            //     inforGroup.listAdmin
            //         // .filter(item => item.permissionType === PERMISSION.EDIT)
            //         .map(item => item.adminId.toString())
            // );
            // const permissionTypes = new Set(
            //     inforGroup.listAdmin
            //         // .filter(item => item.permissionType === PERMISSION.EDIT)
            //         .map(item => item.permissionType)
            // );


            // setSelectedIds(adminIds);
            setDataFilterList(dataDefaulFilterList)
            setListUserSelectedAccount(inforGroup.listAdmin)
        } else {
            setDataFilterList(dataDefaulFilterList)
            // setSelectedIds(new Set())
            setListUserSelectedAccount([])
        }

    }, [inforGroup]);

    useEffect(() => {
        // console.log(inforGroup);

        gListUserAccount()
    }, [dataFilterList, inforGroup])



    return (
        <div className="custom-page-css w-full flex flex-col gap-2 ">
            <div className="custom-page-css flex items-start gap-2">
                <div className="custom-page-css h-fit flex-1 d-flex  gap-2 overflow-hidden">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full">
                            <TreeSelect

                                className="w-full text-left text-span-select custom-input-focus text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                multiple
                                showSearch
                                placeholder="Chọn đơn vị"
                                allowClear
                                value={dataFilterList?.listUnit}
                                treeDefaultExpandAll={false}
                                treeData={sLNationwide}
                                filterTreeNode={(input: string, option: any) =>
                                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setDataFilterList({ ...dataFilterList, listUnit: e })}
                            />

                        </div>
                    </div>
                </div>
                <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
                    <Input
                        placeholder="Tìm kiếm thông tin tài khoản người dùng"

                        className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
                        value={dataFilterList.search}
                        onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
                    />
                    <div className=" border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div>

            </div>

            <div className={`order-history-card__body `}>
                <div className="ag-theme-alpine  custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
                    <AgGridReact
                        className="my-auto-height-grid"
                        getRowStyle={(params: any) => ({
                            backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                        })}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        rowHeight={55}
                        defaultColDef={{
                            resizable: true,
                            flex: 1,
                            valueFormatter: (params: any) =>
                                params.value && String(params.value).trim() !== ""
                                    ? params.value
                                    : "Không xác định",
                        }}
                        alwaysShowHorizontalScroll
                        alwaysShowVerticalScroll
                        overlayNoRowsTemplate={NodataTable}
                        // rowSelection={isEdit ? { mode: 'multiRow' } : undefined}
                        // getRowId={getRowId}
                        // onGridReady={onGridReady}
                        // onSelectionChanged={onSelectionChanged}
                    />
                </div>
                <ConfigProvider locale={viVN}>
                    <div className="pagination-block">
                        <Pagination
                            showSizeChanger
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.total}
                            itemRender={(page, type, originalElement) => {
                                // Chỉ custom khi là nút số trang
                                if (type === 'page') {
                                    return <span>{formatNumber(page)}</span>;
                                }
                                // prev / next / jump-prev / jump-next giữ nguyên
                                return originalElement;
                            }}
                            showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                            className='rs-pagination'
                            onChange={onPaginationChange}
                        />
                    </div>
                </ConfigProvider>
            </div>
        </div>
    )
}
export default React.memo(VG_Decentralization)
